/*=========================================================================================

==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import domainList from "./utils/loginPage";

Vue.use(Router);
const currentDomain = window.location.hostname;
const currentPath = window.location.pathname;
const isLocalhost = currentDomain === "localhost";

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () =>
        import(/*webpackChunkName:"Main"*/ "./layouts/main/Main.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "home",
          component: async () => {
            return import(/*webpackChunkName:"Home"*/ "./views/Home.vue");
          },
        },
        {
          path: "/finansHome",
          name: "finansHome",
          component: () =>
            import(/*webpackChunkName:"FinansHome"*/ "./views/FinansHome.vue"),
        },

        {
          path: "/finans",
          name: "finans",
          component: () =>
            import(/*webpackChunkName:"Finans"*/ "./views/Finans.vue"),
        },
        {
          path: "/priceList",
          name: "priceList",
          component: () =>
            import(
              /*webpackChunkName:"priceListView"*/ "./views/dinamicviewer/priceListView"
            ),
        },
        {
          path: "/countingResults",
          name: "countingResult",
          component: () =>
            import(
              /*webpackChunkName:"countingResultView"*/ "./views/dinamicviewer/countingResultView"
            ),
        },
        {
          path: "/mukayeseListesi",
          name: "mukayeseListesi",
          component: () =>
            import(
              /*webpackChunkName:"mukayeseListesi"*/ "./views/dinamicviewer/mukayeseListesi"
            ),
        },
        {
          path: "/countingSumResults",
          name: "countingSumResult",
          component: () =>
            import(
              /*webpackChunkName:"countingSumResultView"*/ "./views/dinamicviewer/countingSumResultView"
            ),
        },
        {
          path: "/orderList",
          name: "orderList",
          component: () =>
            import(
              /*webpackChunkName:"orderListView"*/ "./views/dinamicviewer/orderListView"
            ),
        },
        {
          path: "/modules/:paramsId",
          props: true,
          component: () =>
            import(
              /*webpackChunkName:"CustomComponentPage"*/ "./views/CustomComponentPage.vue"
            ),
        },
        // {
        //   path: "/B2b/:paramsId",
        //   props: (route) => ({
        //     paramsId: route.params.paramsId,
        //     secondParams: "b2b",
        //   }),
        //   component: () =>
        //     import(
        //       /*webpackChunkName:"CustomComponentPage2"*/ "./views/CustomComponentPage.vue"
        //     ),
        // },
        //system logs
        {
          path: "/cusomview/D7KKullaniciTakipSistemi",
          name: "system_user_fallow",
          component: () =>
            import(
              /*webpackChunkName:"system_user_fallow"*/ "./views/cusomview/D7KKullaniciTakipSistemi.vue"
            ),
        },
        {
          path: "/system/logs",
          name: "system_logs",
          component: () =>
            import(
              /*webpackChunkName:"system_logs"*/ "./views/system/system_logs.vue"
            ),
        },
        {
          path: "/system/notifyView",
          name: "notifyView",
          component: () =>
            import(
              /*webpackChunkName:"notifyView"*/ "./views/system/notifyView.vue"
            ),
        },
        {
          path: "/system/printer",
          name: "system_printer_label",
          component: () =>
            import(
              /*webpackChunkName:"system_printer_label"*/ "./views/system/system_printer_label.vue"
            ),
        },
        {
          path: "/system/requestlogs",
          name: "system_requestlogs",
          component: () =>
            import(
              /*webpackChunkName:"system_request_logs"*/ "./views/system/system_request_logs.vue"
            ),
        },
        {
          path: "/system/customer",
          name: "system_customer",
          component: () =>
            import(
              /*webpackChunkName:"system_customer"*/ "./views/system/system_customer.vue"
            ),
        },
        {
          path: "/system/company/:customerId",
          name: "system_company",
          component: () =>
            import(
              /*webpackChunkName:"system_company"*/ "./views/system/system_company.vue"
            ),
        },
        {
          path: "/system/users/:customerId",
          name: "system_users",
          component: () =>
            import(
              /*webpackChunkName:"system_users"*/ "./views/system/system_users.vue"
            ),
        },
        {
          path: "/system/rolmodul",
          name: "system_rol_modul",
          component: () =>
            import(
              /*webpackChunkName:"system_rol_modul"*/ "./views/system/system_rol_modul.vue"
            ),
        },
        {
          path: "/system/notificationView",
          name: "notificationView",
          component: () =>
            import(
              /*webpackChunkName:"notificationView"*/ "./views/system/notificationView.vue"
            ),
        },
        {
          path: "/system/system_otpLog",
          name: "system_otpLog",
          component: () =>
            import(
              /*webpackChunkName:"system_otpLog"*/ "./views/system/system_otpLog.vue"
            ),
        },
        {
          path: "/system/system_newLogs",
          name: "system_newLogs",
          component: () =>
            import(
              /*webpackChunkName:"system_newLogs"*/ "./views/system/system_newLogs.vue"
            ),
        },
        {
          path: "/system/system_exLogs",
          name: "system_exLogs",
          component: () =>
            import(
              /*webpackChunkName:"system_exLogs"*/ "./views/system/system_exLogs.vue"
            ),
        },
        {
          path: "/system/system_mferror",
          name: "system_mferror",
          component: () =>
            import(
              /*webpackChunkName:"system_mferror"*/ "./views/system/system_mferror.vue"
            ),
        },
        {
          path: "/system/system_profile",
          name: "system_profile",
          component: () =>
            import(
              /*webpackChunkName:"system_profile"*/ "./views/system/system_profile.vue"
            ),
        },
        {
          path: "/system/system_allnotifyview",
          name: "system_allnotifyview",
          component: () =>
            import(
              /*webpackChunkName:"system_allnotifyview"*/ "./views/system/system_allnotifyview.vue"
            ),
        },
        {
          path: "/system/system_userCompany/:customerId/:Id",
          name: "system_userCompany",
          component: () =>
            import(
              /*webpackChunkName:"system_userCompany"*/ "./views/system/system_userCompany.vue"
            ),
        },
        {
          path: "/system/system_contactUs",
          name: "system_contactUs",
          component: () =>
            import(
              /*webpackChunkName:"system_contactUs"*/ "./views/system/system_contactUs.vue"
            ),
        },
        {
          path: "/system/system_componentSettings/:customerId",
          name: "system_componentSettings",
          component: () =>
            import(
              /*webpackChunkName:"system_componentSettings"*/ "./views/system/system_componentSettings.vue"
            ),
        },
        {
          path: "/system/system_roleView",
          name: "system_roleView",
          component: () =>
            import(
              /*webpackChunkName:"system_roleView"*/ "./views/system/system_roleView.vue"
            ),
        },
        {
          path: "/system/system_permissionview/:roleId",
          name: "system_permissionview",
          component: () =>
            import(
              /*webpackChunkName:"system_permissionview"*/ "./views/system/system_permissionview.vue"
            ),
        },
        {
          path: "/system/system_permissionSettingsView/:roleId",
          name: "system_permissionSettingsView",
          component: () =>
            import(
              /*webpackChunkName:"system_permissionSettingsView"*/ "./views/system/system_permissionSettingsView.vue"
            ),
        },
        {
          path: "/system/system_alluser",
          name: "system_alluser",
          component: () =>
            import(
              /*webpackChunkName:"system_alluser"*/ "./views/system/system_alluser.vue"
            ),
        },
        {
          path: "/system/system_allPermission",
          name: "system_allPermission",
          component: () =>
            import(
              /*webpackChunkName:"system_allPermission"*/ "./views/system/system_allPermission.vue"
            ),
        },
        {
          path: "/system/system_tasks",
          name: "system_tasks",
          component: () =>
            import(
              /*webpackChunkName:"system_quests"*/ "./views/system/system_quests.vue"
            ),
        },
        {
          path: "/system/system_modulview",
          name: "system_modulview",
          component: () =>
            import(
              /*webpackChunkName:"system_modulview"*/ "./views/system/system_modulview.vue"
            ),
        },
        {
          path: "/system/system_pageview/:moduleId",
          name: "system_pageview",
          component: () =>
            import(
              /*webpackChunkName:"system_pageview"*/ "./views/system/system_pageview.vue"
            ),
        },
        {
          path: "/system/system_component/:pageId",
          name: "system_component",
          component: () =>
            import(
              /*webpackChunkName:"system_component"*/ "./views/system/system_component.vue"
            ),
        },
        {
          path: "/system/system_queries",
          name: "system_queries",
          component: () =>
            import(
              /*webpackChunkName:"system_queries"*/ "./views/system/system_queries.vue"
            ),
        },
        {
          path: "/system/system_newqueries",
          name: "system_newqueries",
          component: () =>
            import(
              /*webpackChunkName:"system_newqueries"*/ "./views/system/system_newqueries.vue"
            ),
        },
        {
          path: "/system/system_newmacros",
          name: "system_newmacros",
          component: () =>
            import(
              /*webpackChunkName:"system_newmacros"*/ "./views/system/system_newmacros.vue"
            ),
        },
        {
          path: "/system/system_tvuser",
          name: "system_tvuser",
          component: () =>
            import(
              /*webpackChunkName:"system_tvuser"*/ "./views/system/system_tvuser.vue"
            ),
        },
        {
          path: "/system/system_tvPages",
          name: "system_tvPages",
          component: () =>
            import(
              /*webpackChunkName:"system_tvPages"*/ "./views/system/system_tvPages.vue"
            ),
        },
        {
          path: "/system/system_tvcomponent/:tvpageId",
          name: "system_tvcomponent",
          component: () =>
            import(
              /*webpackChunkName:"system_tvcomponent"*/ "./views/system/system_tvcomponent.vue"
            ),
        },
        {
          path: "/system/system_macros",
          name: "system_macros",
          component: () =>
            import(
              /*webpackChunkName:"system_macros"*/ "./views/system/system_macros.vue"
            ),
        },
        {
          path: "/system/system_platform_elements",
          name: "system_platform_elements",
          component: () =>
            import(
              /*webpackChunkName:"system_platform_elements"*/ "./views/system/system_platform_elements.vue"
            ),
        },
        {
          path: "/localadmin/localadmin_kullanicilar",
          name: "localadmin_kullanicilar",
          component: () =>
            import(
              /*webpackChunkName:"kullanicilar"*/ "./views/localadmin/kullanicilar.vue"
            ),
        },
        {
          path: "/localadmin/localadmin_roller",
          name: "localadmin_roller",
          component: () =>
            import(
              /*webpackChunkName:"roller"*/ "./views/localadmin/roller.vue"
            ),
        },
        {
          path: "/localadmin/localadmin_sorgular",
          name: "localadmin_sorgular",
          component: () =>
            import(
              /*webpackChunkName:"sorgular"*/ "./views/localadmin/sorgular.vue"
            ),
        },
        {
          path: "/localadmin/localadmin_makrolar",
          name: "localadmin_makrolar",
          component: () =>
            import(
              /*webpackChunkName:"makrolar"*/ "./views/localadmin/makrolar.vue"
            ),
        },
        {
          path: "/localadmin/localadmin_istekLoglari",
          name: "localadmin_istekLoglari",
          component: () =>
            import(
              /*webpackChunkName:"istekLoglari"*/ "./views/localadmin/istekLoglari.vue"
            ),
        },
        {
          path: "/system/b2b_users",
          name: "b2b_users",
          component: () =>
            import(
              /*webpackChunkName:"b2b_users"*/ "./views/system/b2b_users.vue"
            ),
        },
        {
          path: "/system/system_soapAction",
          name: "system_soapAction",
          component: () =>
            import(
              /*webpackChunkName:"system_soapAction"*/ "./views/system/system_soapAction.vue"
            ),
        },
        {
          path: "/customer_support",
          name: "customer_support",
          component: () =>
            import(
              /*webpackChunkName:"customer_support"*/ "./views/customerSupport/CustomerSupport.vue"
            ),
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () =>
        import(
          /*webpackChunkName:"FullPage"*/ "@/layouts/full-page/FullPage.vue"
        ),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        // =============================================================================
        {
          path: "/m/pivotViewer",
          name: "m-stock",
          component: () =>
            import(
              /*webpackChunkName:"mobilePivotProduct"*/ "@/views/dinamicviewer/mobilePivotProduct.vue"
            ),
        },
        {
          path: "/testPage",
          name: "testPage",
          component: () =>
            import(/*webpackChunkName:"testPage"*/ "./views/testPage.vue"),
        },
        {
          path: "/pages/login",
          name: "page-login",
          component: () =>
            import(/*webpackChunkName:"Login"*/ "@/views/pages/Login.vue"),
        },
        {
          path: "/pages/forgotpassword",
          name: "page-forgot-password",
          component: () =>
            import(
              /*webpackChunkName:"ForgotPassword"*/ "@/views/pages/ForgotPassword.vue"
            ),
        },
        {
          path: "/pages/resetpassword/:code",
          name: "page-reset-password",
          props: true,
          component: () =>
            import(
              /*webpackChunkName:"ResetPassword"*/ "@/views/pages/ResetPassword.vue"
            ),
        },
        {
          path: "/pages/register",
          name: "page-register",
          component: () =>
            import(
              /*webpackChunkName:"Register"*/ "@/views/pages/Register.vue"
            ),
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () =>
            import(
              /*webpackChunkName:"Error404"*/ "@/views/pages/Error404.vue"
            ),
        },
        {
          path: "/pages/error-403",
          name: "page-error-403",
          component: () =>
            import(
              /*webpackChunkName:"NotAuthorized"*/ "@/views/pages/NotAuthorized.vue"
            ),
        },
      ],
    },
    {
      path: "/printerService",
      name: "printer",
      props: true,
      component: () =>
        import(
          /*webpackChunkName:"graphicPrintPage"*/ "./views/dinamicviewer/graphicPrintPage.vue"
        ),
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

const newPath = domainList.find(
  (domain) => domain.path == currentDomain || domain.localPath == currentPath
);

if (newPath) {
  router.addRoute({
    path: isLocalhost ? newPath.localPath : newPath.loginPage, // Dinamik olarak path ekleniyor
    component: newPath.component, // İlgili component
    name: newPath.name, // Rota ismi
  });
}

router.afterEach(() => {
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach(async (to, from, next) => {
  if (to.name != "m-stock") {
    var userToken = localStorage.getItem("UserToken");
    var isAgent = localStorage.getItem("isAgent");

    if (newPath && to.name == "page-login") {
      next({ name: newPath.name });
    } else if (
      to.name == "page-login" ||
      to.name == "page-forgot-password" ||
      to.name == "page-register" ||
      to.name == "page-reset-password" ||
      (newPath && to.name == newPath.name)
    ) {
      if (userToken == null) {
        next();
      } else next("/");
    } else {
      if (userToken == null) {
        if (newPath) {
          next({ name: newPath.name });
        } else {
          next("/pages/login");
        }
      } else {
        if (to.name == "customer_support") {
          if (isAgent === "true") {
            next();
          } else {
            next({ name: "page-error-403" });
          }
        } else {
          next();
        }
      }
    }
  } else {
    next();
  }
});

export default router;
